import { gsap } from "gsap";



const searchToggleElement = document.querySelector('[href="#search"]');
const searchOverlayElement = document.querySelector('[search-overlay]');
const searchContainerElement = searchOverlayElement.querySelector('[search-container]');
const searchInputElement = searchOverlayElement.querySelector('input');
const searchButtonElement = searchOverlayElement.querySelector('button');

searchToggleElement.addEventListener('click', showSearchOverlay);

function showSearchOverlay(e)
{
    searchContainerElement.addEventListener('click', (e) => {
        e.stopPropagation();
    });

    searchOverlayElement.classList.add('visible');
    searchOverlayElement.addEventListener('click', hideSearchOverlay);

    searchInputElement.focus();

    // Animate elements in
    const tlShowSearch = gsap.timeline();
    
    tlShowSearch.set(searchContainerElement, {y: 0});
    tlShowSearch.set(searchButtonElement, {y: -30});

    tlShowSearch.to(searchOverlayElement, {duration: 0.3, ease: 'power.out', opacity: 1});
    tlShowSearch.to(searchContainerElement, {duration: 1, ease: 'power4.inOut', clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'}, '-=0.1');
    tlShowSearch.to(searchInputElement, {duration: 0.5, ease: 'power.out', opacity: 1}, '-=0.6');
    tlShowSearch.to(searchButtonElement, {duration: 0.5, ease: 'back.out(0.5)', y: 0, opacity: 1}, '-=0.4');
    
    e.preventDefault();
}

function hideSearchOverlay(e)
{
    // Animate elements out
    const tlHideSearch = gsap.timeline();

    tlHideSearch.to(searchContainerElement, {duration: 0.5, ease: 'power4.in', opacity: 0, y: 50});
    tlHideSearch.to(searchOverlayElement, {duration: 0.3, ease: 'power.in', opacity: 0, onComplete: () => {
        searchInputElement.value = '';
        searchOverlayElement.classList.remove('visible');
        removeStyleAttributes();
        searchOverlayElement.removeEventListener('click', hideSearchOverlay);
    }});

    e.preventDefault();
}

function removeStyleAttributes()
{
    searchOverlayElement.removeAttribute("style");
    searchContainerElement.removeAttribute("style");
    searchInputElement.removeAttribute("style");
    searchButtonElement.removeAttribute("style");
}